module.exports = __webpack_public_path__ + "static/media/unknown_item_picture.604a084f.svg";